import nodes from './nodes/nodes';
import marks from './marks/marks';
import extensions from './extensions/extensions';

export default [...nodes, ...marks, ...extensions];
